export default "__VITE_ASSET__pe2Lv6Nm__"